import { API_ENDPOINTS } from '../constants/api-endpoint.constants';
import type { TApiPath } from '../types/analytics-events.types';

export const pickApiPaths = () => [...new Set(Object.values(API_ENDPOINTS).map(({ apiPath }) => apiPath))] as [TApiPath, ...Array<TApiPath>];
